import { render, staticRenderFns } from "./majorAdd.vue?vue&type=template&id=97bbe6ba&scoped=true"
import script from "./majorAdd.vue?vue&type=script&lang=ts"
export * from "./majorAdd.vue?vue&type=script&lang=ts"
import style0 from "./majorAdd.vue?vue&type=style&index=0&id=97bbe6ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97bbe6ba",
  null
  
)

export default component.exports